export default __webpack_public_path__ + "static/media/2076.377a6ceb.png";